"use client";

import { c as _c } from "react/compiler-runtime";
import { contrastTheme, darkTheme, defaultTheme, fontSizes } from "@workspace/ui/theme";
import React, { createContext, useContext, useMemo, useReducer } from "react";
import { ThemeProvider as SCThemeProvider } from "styled-components";
import packageJson from "../../../package.json";
export let ThemeActionType = /*#__PURE__*/function (ThemeActionType) {
  ThemeActionType["TOGGLE_THEME"] = "TOGGLE_THEME";
  ThemeActionType["TOGGLE_DRAWER"] = "TOGGLE_DRAWER";
  ThemeActionType["SET_THEME"] = "SET_THEME";
  ThemeActionType["SCALE_FONT"] = "SCALE_FONT";
  ThemeActionType["SET_CONTRAST"] = "SET_CONTRAST";
  ThemeActionType["RESET"] = "RESET";
  return ThemeActionType;
}({});
const ThemeStateContext = createContext(undefined);
const ThemeDispatchContext = createContext(undefined);
const initialThemeState = {
  theme: defaultTheme,
  openDrawer: true,
  isDark: false
};
function themeReducer(state, action) {
  switch (action.type) {
    case ThemeActionType.TOGGLE_THEME:
      localStorage.setItem("isDark", String(!state.isDark));
      localStorage.setItem("theme", !state.isDark ? JSON.stringify(darkTheme) : JSON.stringify(defaultTheme));
      return {
        ...state,
        isDark: !state.isDark,
        theme: !state.isDark ? darkTheme : defaultTheme
      };
    case ThemeActionType.TOGGLE_DRAWER:
      localStorage.setItem(`tripsobotOpenDrawer${process.env.NEXT_PUBLIC_ENV === "development" ? "Dev" : ""}${packageJson.version}`, JSON.stringify(action.open));
      return {
        ...state,
        openDrawer: action.open
      };
    case ThemeActionType.SET_THEME:
      localStorage.setItem("theme", JSON.stringify(action.theme));
      return {
        ...state,
        isDark: action.isDark,
        theme: action.theme
      };
    case ThemeActionType.SCALE_FONT:
      {
        const updatedTheme = {
          ...state.theme
        };
        const scaleFactor = action.direction === "up" ? 0.1 : -0.1;
        const sizesToScale = ["xxs", "xs", "s", "m", "l", "xl", "xxl", "xxxl"];
        sizesToScale.forEach(size => {
          const currentSize = parseFloat(updatedTheme.fontSizes[size]);
          updatedTheme.fontSizes[size] = `${currentSize + scaleFactor}rem`;
        });
        localStorage.setItem("theme", JSON.stringify(updatedTheme));
        return {
          ...state,
          theme: updatedTheme
        };
      }
    case ThemeActionType.SET_CONTRAST:
      state.theme = contrastTheme;
      localStorage.setItem("theme", JSON.stringify(state.theme));
      return {
        ...state
      };
    case ThemeActionType.RESET:
      {
        // Stwórz nowy obiekt motywu z domyślnymi rozmiarami czcionek
        const resetTheme = {
          ...defaultTheme,
          fontSizes: {
            ...fontSizes
          }
        };
        localStorage.setItem("theme", JSON.stringify(resetTheme));
        localStorage.setItem("isDark", "false");
        return {
          ...state,
          theme: resetTheme,
          isDark: false
        };
      }
    default:
      throw new Error("Unhandled action");
  }
}
export function ThemeProvider(t0) {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [state, dispatch] = useReducer(themeReducer, initialThemeState);
  let t1;
  t1 = state;
  let t2;
  if ($[0] !== children || $[1] !== state.theme) {
    t2 = <SCThemeProvider theme={state.theme}>{children}</SCThemeProvider>;
    $[0] = children;
    $[1] = state.theme;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2) {
    t3 = <ThemeDispatchContext.Provider value={dispatch}><ThemeStateContext.Provider value={t1}>{t2}</ThemeStateContext.Provider></ThemeDispatchContext.Provider>;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export function useThemeState() {
  const state = useContext(ThemeStateContext);
  if (!state) {
    throw new Error("ThemeProvider not found");
  }
  return state;
}
export function useThemeDispatch() {
  const dispatch = useContext(ThemeDispatchContext);
  if (!dispatch) {
    throw new Error("ThemeProvider not found");
  }
  return dispatch;
}
export const useTheme = () => {
  const $ = _c(17);
  const state = useThemeState();
  const dispatch = useThemeDispatch();
  let t0;
  if ($[0] !== dispatch) {
    t0 = () => dispatch({
      type: ThemeActionType.TOGGLE_THEME
    });
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleTheme = t0;
  let t1;
  if ($[2] !== dispatch) {
    t1 = open => dispatch({
      type: ThemeActionType.TOGGLE_DRAWER,
      open
    });
    $[2] = dispatch;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setOpenDrawer = t1;
  let t2;
  if ($[4] !== dispatch) {
    t2 = direction => dispatch({
      type: ThemeActionType.SCALE_FONT,
      direction
    });
    $[4] = dispatch;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const scaleFont = t2;
  let t3;
  if ($[6] !== dispatch) {
    t3 = () => dispatch({
      type: ThemeActionType.SET_CONTRAST
    });
    $[6] = dispatch;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const setContrast = t3;
  let t4;
  if ($[8] !== dispatch) {
    t4 = () => dispatch({
      type: ThemeActionType.RESET
    });
    $[8] = dispatch;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const resetTheme = t4;
  let t5;
  if ($[10] !== resetTheme || $[11] !== scaleFont || $[12] !== setContrast || $[13] !== setOpenDrawer || $[14] !== state || $[15] !== toggleTheme) {
    t5 = {
      state,
      toggleTheme,
      setOpenDrawer,
      scaleFont,
      setContrast,
      resetTheme
    };
    $[10] = resetTheme;
    $[11] = scaleFont;
    $[12] = setContrast;
    $[13] = setOpenDrawer;
    $[14] = state;
    $[15] = toggleTheme;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
};